export enum CmsRegionType {
    SIM = 'esim',
    GIFT_CARD = 'giftCard',
    BOTH = 'both'
}

export type CmsRegion = {
    id: number
    name: string
    order: number
    type: CmsRegionType
    iconUrl?: string | null
}
